module.exports = __webpack_public_path__ + "static/media/nuova-1-comp.233b0540.jpg";